import { useEffect } from 'react';
import { CheckIcon, Close, Modify } from 'assets/icons';
import Button from 'components/button';
import Divider from 'components/divider/divider';
import UseModal from 'components/modal/useModal';
import UseContext from 'hooks/useContext';

const STATUS_STYLES = {
  2: { bg: 'bg-red-50', icon: '#B91C1C' },
  3: { bg: 'bg-green-100', icon: '#047857' },
};

/** Same as ficheHour: API / aggregation may return validated as number or string. */
const normalizeTimeSheetValidated = (v) => {
  const n = Number(v);
  return [0, 1, 2, 3].includes(n) ? n : 0;
};

const renderPeriods = (item, prefix = '') => {
  const p1 = item?.[`periode_one${prefix}`];
  const p2 = item?.[`periode_two${prefix}`];
  const p3 = item?.[`periode_three${prefix}`];
  const parts = [];
  if (p1?.start && p1.start !== '' && p1.start !== '00:00') parts.push(`${p1.start} > ${p1.end}`);
  if (p2?.start && p2.start !== '') parts.push(`${p2.start} > ${p2.end}`);
  if (p3?.start && p3.start !== '') parts.push(`${p3.start} > ${p3.end}`);
  return parts.join(', ') || null;
};

const TBodyHoursCompany = ({ champsBody }) => {
  const { timeCheck, setTimeCheck, setTimeData, objID, setObjID } = UseContext();
  const { toggle } = UseModal();

  useEffect(() => {
    if (!champsBody?.days) return;
    const initial = {};
    champsBody.days.forEach((day) => {
      const dv = normalizeTimeSheetValidated(day.validated);
      if (dv !== 1) initial[day._id] = dv;
    });
    setTimeCheck((prev) => ({ ...prev, ...initial }));
  }, [champsBody]);

  const toggleDayStatus = (e, dayId, targetStatus) => {
    e.preventDefault();
    setTimeCheck((prev) => ({
      ...prev,
      [dayId]: prev[dayId] === targetStatus ? '' : targetStatus,
    }));
  };

  const handleModal = (e, dayValidation, index, id) => {
    e.preventDefault();
    const dv = normalizeTimeSheetValidated(dayValidation);
    if (dv === 1 || dv === 2) {
      toggle('doc_c_completedHours');
      setObjID(champsBody.id_time_sheet);
      setTimeData((prev) => ({ ...prev, index, id, id_time_sheet: objID }));
    }
  };

  const sheetValidatedNum = normalizeTimeSheetValidated(champsBody?.validated);

  return (
    <>
      {champsBody?.days.map((item, index) => {
        const dayValidatedNum = normalizeTimeSheetValidated(item?.validated);
        const rawCheck = timeCheck[item?._id];
        const checkNum =
          rawCheck === '' || rawCheck === undefined || rawCheck === null
            ? null
            : normalizeTimeSheetValidated(rawCheck);
        const isModified = checkNum === 2;
        const isValidated = checkNum === 3;
        const style = checkNum !== null ? STATUS_STYLES[checkNum] : undefined;
        const hasCompanyPeriod = item?.periode_one_company && dayValidatedNum === 2;

        return (
          <div key={item._id}>
            <div className="flex items-center grid grid-cols-5">
              <div className={`ft-sm w-auto font-medium ${isModified ? 'text-yellow-500' : 'text-gray-900'}`}>
                {item.name}
              </div>
              <div className={`col-span-3 flex flex-col gap-2 ft-sm ${isModified ? 'text-yellow-200' : 'text-gray-500'}`}>
                <span className={`ft-sm font-medium ${isModified ? 'text-yellow-500' : 'text-gray-900'}`}>
                  {item?.periode_one_company?.start !== '00:00'
                    ? (item.day_hours_ent || item.day_hours_ent === '0' ? `${item.day_hours_ent} travaillées` : null)
                    : null}
                </span>
                <div>
                  {hasCompanyPeriod ? (
                    <>
                      <del>{renderPeriods(item)}</del>
                      <div className="text-yellow-200">
                        {item.periode_one_company?.start !== '00:00'
                          ? renderPeriods(item, '_company')
                          : 'Jour non travaillé'}
                      </div>
                    </>
                  ) : (
                    renderPeriods(item)
                  )}
                </div>
              </div>
              <div className="flex items-center justify-end gap-2">
                {dayValidatedNum === 2 && (
                  <Button
                    color="ICON"
                    size="ICON"
                    onClick={(e) => handleModal(e, dayValidatedNum, index, item._id)}
                  >
                    <Modify wh={15} color="#111827" />
                  </Button>
                )}
                {sheetValidatedNum !== 0 && (
                  <>
                    {sheetValidatedNum !== 2 && (
                      <Button
                        color={isModified ? 'REFUSED' : 'ICON'}
                        size="ICON"
                        onClick={(e) => toggleDayStatus(e, item._id, 2)}
                        className={isModified && style ? style.bg : ''}
                      >
                        <Close wh={24} color={isModified && style ? style.icon : '#374151'} />
                      </Button>
                    )}
                    <Button
                      color={isValidated ? 'DEFAULT' : 'ICON'}
                      size="ICON"
                      onClick={(e) => toggleDayStatus(e, item._id, 3)}
                      className={isValidated && style ? style.bg : ''}
                    >
                      <CheckIcon w={15} color={isValidated && style ? style.icon : '#374151'} />
                    </Button>
                  </>
                )}
              </div>
            </div>
            <Divider w={100} />
          </div>
        );
      })}
    </>
  );
};

export default TBodyHoursCompany;
